import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import logo from '../logo-optimized.jpg';

const ChatFAB = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Don't show FAB on the actual chat page
  if (location.pathname === '/chat') return null;

  return (
    <button
      onClick={() => navigate('/chat')}
      aria-label="Chat with FUDChat AI"
      className="fixed bottom-4 right-4 md:bottom-8 md:right-8 z-40 bg-fud-gold hover:bg-fud-gold-light text-fud-dark p-3.5 md:p-4 rounded-full shadow-2xl transition-all transform hover:scale-105 active:scale-95 group border-2 border-white/20 flex items-center gap-2"
    >
      <div className="relative">
        <div className="bg-white p-0.5 rounded-full">
          <img src={logo} alt="" className="h-6 w-6 md:h-7 md:w-7 object-contain rounded-full" />
        </div>
        <span aria-hidden="true" className="absolute -top-1 -right-1 flex h-3 w-3">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-fud-green opacity-75"></span>
          <span className="relative inline-flex rounded-full h-3 w-3 bg-fud-green border border-white"></span>
        </span>
      </div>
      {/* The label only expands on hover, so it must never be the only name for
          the control — the button carries an aria-label. Hidden on touch devices
          where there is no hover to reveal it. */}
      <span className="hidden md:block max-w-0 group-hover:max-w-xs group-focus-visible:max-w-xs overflow-hidden transition-all duration-300 font-bold text-sm whitespace-nowrap">
        Chat
      </span>

      {/* Tooltip on Desktop */}
      <span
        aria-hidden="true"
        className="hidden md:block absolute right-full mr-3 top-1/2 -translate-y-1/2 bg-fud-dark text-white text-xs py-2 px-4 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none shadow-2xl border border-white/10"
      >
        Chat with your AI Bestie! 🚀
      </span>
    </button>
  );
};

export default ChatFAB;
